export const splitPracticeDetails = (practice: string): { name: string; odsCode: string } => {
    const slicePoint = practice.lastIndexOf(' ');
    const name = practice.slice(0, slicePoint);
    const odsCode = practice.slice(slicePoint + 1);
    return { name, odsCode };
};
